module.exports = __webpack_public_path__ + "img/description-3.ed8bc481.png";